<div class="position-relative d-flex align-items-center image">
  @if (item) {
    @if (item.gallery?.length > 1 && showImagesCounter) {
      <span class="mat-caption image-counter">
        {{ item.gallery?.length || 0 }} {{ 'COMMON.LABEL.IMAGES' | translate }}
      </span>
    }
    @if (item.gallery?.length) {
      <img
        [src]="
          $safeNavigationMigration(
            item.gallery[item.galleryImageIndex]?.image?.getImageByFormat(imageSize)?.url
          )
        "
        [alt]="item.description"
        [title]="item.description"
        loading="lazy"
      />
    }
    @if (!item.gallery?.length) {
      <img src="/assets/img/placeholder-image.png" />
    }
    @if (item.gallery?.length) {
      <span class="position-absolute image-type d-flex flex-column">
        @if (item.lookbooks_to?.length) {
          <mat-icon
            [color]="item.gallery[item.galleryImageIndex]?.type === 'lookbooks_to' ? 'accent' : 'primary'"
            [matTooltip]="
              item.gallery[item.galleryImageIndex]?.type === 'lookbooks_to'
                ? ('COMMON.LABEL.LOOKBOOK' | translate) +
                  ': ' +
                  item.gallery[item.galleryImageIndex]?.inventory
                : ''
            "
            class="mb-2 material-icons-outlined"
          >
            portrait
          </mat-icon>
        }
        @if (item.lookbooks_from?.length) {
          <mat-icon
            [color]="item.gallery[item.galleryImageIndex]?.type === 'lookbooks_from' ? 'accent' : 'primary'"
            [matTooltip]="
              item.gallery[item.galleryImageIndex]?.type === 'lookbooks_from'
                ? ('COMMON.LABEL.ITEM' | translate) + ': ' + item.gallery[item.galleryImageIndex]?.inventory
                : ''
            "
            class="mb-2"
          >
            checkroom
          </mat-icon>
        }
        @if (item.links?.length) {
          <mat-icon
            [color]="item.gallery[item.galleryImageIndex]?.type === 'link' ? 'accent' : 'primary'"
            [matTooltip]="
              item.gallery[item.galleryImageIndex]?.type === 'link'
                ? ('COMMON.LABEL.LINK' | translate) + ': ' + item.gallery[item.galleryImageIndex]?.inventory
                : ''
            "
          >
            link
          </mat-icon>
        }
      </span>
    }
    <div class="slideshow-buttons">
      @if (item.gallery?.length > 1) {
        <button mat-icon-button class="left arrow" (click)="showPreviousImage($event)">
          <mat-icon>chevron_left</mat-icon>
        </button>
      }
      @if (item.gallery?.length > 1) {
        <button mat-icon-button class="right arrow" (click)="showNextImage($event)">
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>
  }
</div>
